import httpClient from "modules/http-client";
import { EnvironmentVariables } from "models/environment";
import env from "modules/env/env";

export class UserDeleteApi {
  deleteCurrentUser() {
    const endpoint = env(EnvironmentVariables.deleteEndpoint);
    return httpClient.delete(endpoint!);
  }
  reasonDeleteCurrentUser(reason: string) {
    const body = {
      reason,
    };
    const endpoint = env(EnvironmentVariables.deleteReasonEndpoint);
    return httpClient.post(endpoint!, body);
  }
  eligibletoDeleteUser() {
    const endpoint = env(EnvironmentVariables.eligibleToDeleteEndpoint);
    return httpClient.get(endpoint!);
  }
}
